import { Component, OnInit, NgZone, signal } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@app/_services';
import { faSignInAlt, faUserPlus, faTachometerAlt, faEye, faEyeSlash, faKey } from '@fortawesome/free-solid-svg-icons';
import { ToastrService } from 'ngx-toastr';
import { first, finalize } from 'rxjs/operators';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: false
})
export class LoginComponent implements OnInit {

    loginForm!: FormGroup;
    loading = signal(false);
    submitted = signal(false);
    returnUrl: string | undefined;
    error = signal('');
    showPassword = signal(false);

    pastLogin = signal(false);

    faSignInAlt = faSignInAlt;
    faUserPlus = faUserPlus;
    faTachometerAlt = faTachometerAlt;
    faEye = faEye;
    faEyeSlash = faEyeSlash;
    faKey = faKey;

    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private toastr: ToastrService,
        private router: Router,
        private authenticationService: AuthenticationService,
        private ngZone: NgZone
    ) {
        // redirect to home if already logged in
        if (this.authenticationService.currentUserValue) {
            this.router.navigate(['/home']);
        }
    }

    ngOnInit() {
        this.loginForm = this.formBuilder.group({
            username: ['', Validators.required],
            password: ['', Validators.required]
        });

        // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';

        this.pastLogin.set(localStorage.getItem('offlineUser') != undefined && localStorage.getItem('offlineUser')!.includes('username'));
    }

    // convenience getter for easy access to form fields
    get f() { return this.loginForm.controls; }

    openRegistration() {
        this.router.navigate(['/registration']);
    }

    openForgetPassword() {
        this.router.navigate(['/forget-password']);
    }

    openQuickAccess() {
        //check localstorage

        if (localStorage.getItem('offlineUser') != undefined && localStorage.getItem('offlineUser')!.includes('username')) {
            this.router.navigate(['/quick-access/start'])
        }
    }

    togglePasswordVisibility() {
        this.showPassword.set(!this.showPassword());
    }

    onSubmit() {
        this.submitted.set(true);

        // stop here if form is invalid
        if (this.loginForm.invalid) {
            return;
        }

        this.loading.set(true);
        this.authenticationService.login(this.f.username.value, this.f.password.value)
            .pipe(
                first(),
                finalize(() => this.ngZone.run(() => this.loading.set(false)))
            )
            .subscribe({
                next: (data) => {
                    if (data.access_token) {
                        this.toastr.success('Login successful.','Success');
                        this.router.navigate(['/home']);
                    } else {
                        this.toastr.error('Username/Password does not match', 'Error');
                        this.error.set('Username/Password does not match');
                    }
                },
                error: (error) => {
                    this.toastr.error('Login failed.', 'Failed');
                    this.error.set(error);
                }
            });
    }
}
